"use client";

/** The takeover CTA — used in the hero and the nav. Desktop-only (editing
 * TipTap on a phone is a bad first impression); prefetches the demo chunk on
 * hover/focus so the transition feels instant. */

import { PencilLine } from "lucide-react";
import { useContext } from "react";
import { DemoTriggerContext } from "./LandingDemoShell";

export default function EditThisPageButton({ variant }: { variant: "hero" | "nav" }) {
  const trigger = useContext(DemoTriggerContext);
  if (!trigger) return null;

  // Desktop gating lives on a wrapper: .ld-cta-ghost is unlayered CSS whose
  // `display` would beat Tailwind's layered `hidden` utility on the button
  // itself. `lg:contents` makes the wrapper vanish from layout on desktop.
  if (variant === "nav") {
    return (
      <span className="hidden lg:contents">
        <button
          onClick={trigger.open}
          onPointerEnter={trigger.prefetch}
          onFocus={trigger.prefetch}
          className="ld-cta-ghost !px-3.5 !py-2 text-sm"
        >
          <PencilLine className="h-3.5 w-3.5" />
          Try the editor
        </button>
      </span>
    );
  }

  return (
    <span className="hidden lg:contents">
      <button
        onClick={trigger.open}
        onPointerEnter={trigger.prefetch}
        onFocus={trigger.prefetch}
        className="ld-cta-ghost"
        title="Open this very page in the real LessonFresh editor — nothing is saved"
      >
        <PencilLine className="h-4 w-4" />
        This page was written in LessonFresh — try the editor
      </button>
    </span>
  );
}
